export const DATES = {
	loadDateFormat: 'dd MMM yyyy | h:mm a',
	loadDateFormatNoTime: 'dd MMM yyyy',
	usFormat: 'dd MMM yyyy',
	BEDate: 'yyyy-MM-dd',
	BEDateTime: "yyyy-MM-dd'T'HH:mm:ss",
	dateInputFormat: 'dd/MM/yyyy',
	dateTimeInputFormat: 'dd/MM/yyyy HH:mm',
};
